const STORY_PROGRESS_MILESTONES = [25, 50, 75, 100];

function finiteNumber(value, fallback = 0) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
}

function roundMetric(value, decimals = 2) {
    const factor = Math.pow(10, decimals);
    return Math.round(finiteNumber(value) * factor) / factor;
}

function createStoryWatchSession(nowMs = Date.now()) {
    return {
        startedAtMs: finiteNumber(nowMs, Date.now()),
        playingStartedAtMs: null,
        watchedMs: 0,
        maxProgressPercent: 0,
        reachedMilestones: []
    };
}

function resumeStoryWatch(session, nowMs = Date.now()) {
    if (session && session.playingStartedAtMs === null) {
        session.playingStartedAtMs = finiteNumber(nowMs, Date.now());
    }
    return session;
}

function pauseStoryWatch(session, nowMs = Date.now()) {
    if (!session || session.playingStartedAtMs === null) return session;

    session.watchedMs += Math.max(0, finiteNumber(nowMs, Date.now()) - session.playingStartedAtMs);
    session.playingStartedAtMs = null;
    return session;
}

function getStoryWatchTimeMs(session, nowMs = Date.now()) {
    if (!session) return 0;

    const activeSegmentMs = session.playingStartedAtMs === null
        ? 0
        : Math.max(0, finiteNumber(nowMs, Date.now()) - session.playingStartedAtMs);
    return Math.max(0, session.watchedMs + activeSegmentMs);
}

function updateStoryProgress(session, currentTime, duration) {
    if (!session) return [];

    const safeDuration = finiteNumber(duration);
    const safeCurrentTime = finiteNumber(currentTime);
    if (safeDuration <= 0 || safeCurrentTime < 0) return [];

    const progress = Math.max(0, Math.min(100, (safeCurrentTime / safeDuration) * 100));
    session.maxProgressPercent = Math.max(session.maxProgressPercent, progress);

    const newlyReached = STORY_PROGRESS_MILESTONES.filter(milestone => (
        progress >= milestone && !session.reachedMilestones.includes(milestone)
    ));
    session.reachedMilestones.push(...newlyReached);
    return newlyReached;
}

function summarizeStoryWatch(session, nowMs = Date.now(), videoDuration = 0) {
    pauseStoryWatch(session, nowMs);

    const elapsedMs = session
        ? Math.max(0, finiteNumber(nowMs, Date.now()) - session.startedAtMs)
        : 0;

    return {
        watch_time_seconds: roundMetric((session?.watchedMs || 0) / 1000),
        elapsed_time_seconds: roundMetric(elapsedMs / 1000),
        video_duration_seconds: roundMetric(videoDuration),
        max_progress_percent: roundMetric(session?.maxProgressPercent || 0, 1),
        completed: (session?.maxProgressPercent || 0) >= 95
    };
}

export {
    STORY_PROGRESS_MILESTONES,
    createStoryWatchSession,
    getStoryWatchTimeMs,
    pauseStoryWatch,
    resumeStoryWatch,
    roundMetric,
    summarizeStoryWatch,
    updateStoryProgress
};
